// extracted by css-extract-rspack-plugin
export default {"Octicon":"blankslate-error-message-module__Octicon__c5vfm","Text":"blankslate-error-message-module__Text__VqO8M"};